import { render, staticRenderFns } from "./order-table-group.component.vue?vue&type=template&id=1cb09641&"
import script from "./order-table-group.component.vue?vue&type=script&lang=js&"
export * from "./order-table-group.component.vue?vue&type=script&lang=js&"
import style0 from "./order-table-group.component.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ksaffer/Projects/Client/natorp-plant-database/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1cb09641')) {
      api.createRecord('1cb09641', component.options)
    } else {
      api.reload('1cb09641', component.options)
    }
    module.hot.accept("./order-table-group.component.vue?vue&type=template&id=1cb09641&", function () {
      api.rerender('1cb09641', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "_src/js/components/order-table-group.component.vue"
export default component.exports